'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './quickbooks-import.routes';

export class QuickbooksImportComponent {
  constructor(QuickbooksImportService, PropertyService, CommunityService, Upload, $scope, $timeout) {
    'ngInject';
    //this.data = require('./sample.json');
    this.QuickbooksImportService = QuickbooksImportService;
    this.PropertyService = PropertyService;
    this.Upload = Upload;
    this.$scope = $scope;
    this.$timeout = $timeout;

    this.importProgress = 0;
    this.progressType = "primary"; // success, danger, warning

    this.mapByOwner = {};
    this.mapTotalByOwner = {};
    this.mapOwnerChecked = {};
    this.mapContactId = {};
    this.mapQuickbooksNameContactId = {};

    this.countEntries = 0;
    this.countChecks = 0;

    this.contacts = [];
    this.unassignedContacts = [];

    CommunityService.query(data => {
      this.communities = data.map(community => {
        return {
          value: community._id,
          name: community.name
        }
      });
    });

    this.data = [];
    this.owners = [];
  }

  doAnalyze() {
    let currentOwner = null;

    // find required headers
    let HEADER = {"Type": null, "Date": null, "Account": null, "Amount": null, "Balance": null};

    let headerIdx = -1;
    let HEADER_FIND_ARR = Object.keys(HEADER);
    for (let i=0; i<= this.data.length; i++) {
      if (this.data[i].some(col => HEADER_FIND_ARR.includes(col))) {
        headerIdx = i;
        console.log("Header row found at " + headerIdx);
        break;
      }
    }

    if (headerIdx === -1) {
      alert('This file does not meet the requirements for data import: No header row found');
      return;
    }

    for (let i=0; i<= this.data[headerIdx].length; i++) {
      if (this.data[headerIdx][i]) {
        HEADER[this.data[headerIdx][i]] = i;
      }
    }

    for (let idx in HEADER) {
      if (!HEADER[idx]) {
        alert('This file does not meet the requirements for data import: Type, Date, Account, Amount and Balance required');
        return;
      }
    }

    this.data.forEach((entry, idx) => {

      if (idx <= headerIdx) {
        console.log("Ignoring row " + idx);
        return;
      }

      try {
        if (!entry.length || entry[HEADER["Type"]] == "Type" || entry[0] == "TOTAL")  // ignore header and footer
          return;

        if (entry[1] && !entry[1].startsWith('Total')) {
          if (entry[1] == 'zz Accounting use only') {
            currentOwner = 'zz Accounting use only';
          } else {
            currentOwner = entry[1].trim();

            this.mapByOwner[currentOwner] = [];
          }
          return;
        } else if (entry[1] && currentOwner != 'zz Accounting use only') {
          this.mapTotalByOwner[currentOwner] = entry[HEADER["Balance"]];
          this.mapOwnerChecked[currentOwner] = true;
          return;
        }

        if (currentOwner == 'zz Accounting use only')
          return;

        this.mapByOwner[currentOwner].push({
          "type": entry[HEADER["Type"]],
          "date": entry[HEADER["Date"]],
          "num": HEADER["Num"] ? entry[HEADER["Num"]] : entry[8],  // not sure what this is, but I will save it anyways in case it is useful
          "account": entry[HEADER["Account"]],
          "amount": parseFloat(entry[HEADER["Amount"]]), //parseFloat(String(entry[12]).replace('.','').replace(',','.')),
          "name": currentOwner,
          "meta":{active: true}
        })
      } catch(e){
        console.log(e);
      }
    });

    this.owners = Object.keys(this.mapTotalByOwner);
    this.updateMappingInfo();
    this.$scope.$apply();
  }

  getContactById(id) {
    let contact = this.contacts.find(o => o.id == id);
    if (contact) {
      return contact.name;
    }
  }

  updateMappingInfo(owner, removed) {
    this.dirty = true;
    let contactId = this.mapContactId[owner];
    let contact = this.contacts.find(o => o.id == contactId);
    if (contact) {
      contact.state = (removed) ? "Unassigned" : "Assigned";
    }
    this.unassignedContacts = this.contacts.filter(contact => contact.state == "Unassigned");
    this.$timeout(_ => {
      this.dirty = false;
    },0);
  }

  prevent(e) {
    e.stopPropagation();
    e.preventDefault();
  }

  getCheckCount() {
    //return this.owners.filter(owner => this.mapOwnerChecked[owner]).length;
  }

  getEntryCount() {
    //return this.owners.filter(owner => this.mapOwnerChecked[owner]).reduce((acc, owner)=> acc + this.mapByOwner[owner].length, 0)
  }

  import() {
    /* assign community and contact (if assigned) to each line item */
    this.owners.forEach(owner => {
      /* community */
      this.mapByOwner[owner].forEach(entry => {
        entry.community = this.selectedCommunityId;
      });

      /* contact */
      if (this.mapContactId[owner]) {
        this.mapByOwner[owner].forEach(entry => {
          entry.property = this.mapContactId[owner];
        })
      }
    });

    /* import */
    let datasets = this.owners.filter(owner => this.mapOwnerChecked[owner]);
    let count = 0;
    datasets.forEach(dataset => {
      this.QuickbooksImportService.createBulk({name: dataset, communityId: this.selectedCommunityId}, this.mapByOwner[dataset], success => {
        count++;
        if (count == datasets.length) {
          this.progressType = "success";
          this.importProgress = 100;
        } else {
          this.importProgress = count / datasets.length;
        }
      }, err => {
        this.progressType = "danger";
        console.log(err);
      })
    })
  }

  analyze(file) {
    var reader = new FileReader();
    reader.onload = e => {
      var data = e.target.result;
      let workbook = XLSX.read(data, {type: 'binary', cellDates:true});
      this.data = XLSX.utils.sheet_to_json(workbook.Sheets["Sheet1"], {header:1});

      this.doAnalyze();
    };
    reader.readAsBinaryString(file);
  }

  getComposedName(contact) {
    let composedName = "";

    if (contact.lastName && contact.firstName) {
      composedName = contact.lastName + ", " + contact.firstName;
      if (contact.middleName)
        composedName += " " + contact.middleName;
    }

    if (contact.company) {
      if (composedName == "")
        composedName += contact.company;
      else
        composedName += " (" + contact.company + ")";
    }

    return composedName || "-";
  }

  changeCommunitySelection() {
    this.contacts = [];
    this.mapContactId = {};
    this.mapQuickbooksNameContactId = {};

    this.PropertyService.getByCommunity({communityId: this.selectedCommunityId}, data => {
      data.forEach(property => {
        property.contacts
          .filter(contact => contact.type == "primary-owner" && contact.contact && contact.contact._id)
          .map(contact => {
            return {
              'id': property._id,
              'name': property.lotNo + " - " + this.getComposedName(contact.contact),
              'quickbooksName': (property.customFields && property.customFields.quickbooksName) ? property.customFields.quickbooksName : ''
          }})
          .forEach(contact => {
            if (contact.quickbooksName) {
              this.mapQuickbooksNameContactId[contact.quickbooksName] = contact.id;
            }

            contact.state = "Unassigned";
            this.contacts.push(contact);
          });

        // Assign Quickbook Name Relations
        this.owners.forEach(owner => {
          if (this.mapQuickbooksNameContactId[owner]) {
            this.mapContactId[owner] = this.mapQuickbooksNameContactId[owner];

            let contactId = this.mapContactId[owner];
            let contact = this.contacts.find(o => o.id == contactId);
            if (contact) {
              contact.state = "Assigned";
            }
          }
        });

        this.unassignedContacts = this.contacts.filter(contact => contact.state == "Unassigned");
      });
    }, _err => {
      console.log(_err);
    })
  }
}

export default angular.module('conduu.quickbooksImport', [uiRouter])
  .config(routes)
  .component('quickbooksImport', {
    template: require('./quickbooks-import.html'),
    controller: QuickbooksImportComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/import/quickbooks/quickbooks-import.component.js